import { useMutation, useQuery } from "@tanstack/react-query";

import { QUERY_KEYS } from "@/api/constants";
import type { PaginationParams } from "@/types/api";

import { apiRoleManagement } from "./apiRoleManagment";
import type {
  IAssignmentsUserToRole,
  ICreateUserRole,
  IUserRole,
} from "./types";

export const useGetAllUsersRolesQuery = (params?: PaginationParams) => {
  return useQuery({
    queryKey: [QUERY_KEYS.allUsersRoles, params],
    queryFn: () => apiRoleManagement.getAllUsersRoles(params),
  });
};

export const useGetUserRoleByIdQuery = (id?: string, enabled = true) => {
  return useQuery<IUserRole>({
    queryKey: [QUERY_KEYS.allUsersRoles, id],
    queryFn: () => {
      if (!id) throw new Error("ID is required");
      return apiRoleManagement.getUserRoleById(id);
    },
    enabled: Boolean(id) && Boolean(enabled),
  });
};

export const useUpdateRoleStatusMutation = () => {
  return useMutation({
    mutationFn: ({ id, data }: { id: string; data: { active: boolean } }) => {
      return apiRoleManagement.patchRoleStatus(id, data);
    },
  });
};

export const useCreateRolerMutation = () => {
  return useMutation({
    mutationFn: (data: ICreateUserRole) => {
      return apiRoleManagement.postNewRole(data);
    },
  });
};

export const useAssignUserToRoleMutation = () => {
  return useMutation({
    mutationFn: ({ data }: { data: IAssignmentsUserToRole }) => {
      return apiRoleManagement.postNewAssignmentRole(data);
    },
  });
};
